import React from 'react';
import { observer } from 'mobx-react-lite';
import { InboxComponent } from '../../components/inbox';
import { AdminPageLayout, PageTitle } from '../../components/uiComponents/UIComponents';

export const InboxPage: React.FC = observer(() => {
    return <AdminPageLayout header={<PageTitle>Inbox</PageTitle>} content={<InboxComponent />} />;
});
